import { type PropsOf } from '@blaze-runtime/engine-domain';
import {
  getBackground,
  type LabelIconAlignment,
  makeFontStyles,
  makeFontStyleStyles,
  makeLabelHorizontalAlignStyles,
  type ToggleButtonStateKey,
} from '@blaze-shared/elements-domain';

export type ToggleButtonStateStyle =
  PropsOf<'toggleButton'>['style']['states'][ToggleButtonStateKey];

export interface ToggleButtonStateStyles {
  buttonStyles: Record<string, string>;
  wrapperStyles: Record<string, string>;
}

export function toggleStateToBoolean(state: ToggleButtonStateKey | undefined): boolean {
  return state === 'enabled';
}

export function booleanToToggleState(value: boolean): ToggleButtonStateKey {
  return value ? 'enabled' : 'disabled';
}

export function makeToggleButtonStateStyles(
  stateStyle: ToggleButtonStateStyle,
  iconPosition: LabelIconAlignment | undefined,
  fontWeight: string,
  isUsingOldPaddingStrategy: boolean,
): ToggleButtonStateStyles {
  const { label, font, background } = stateStyle;

  const wrapperStyles: Record<string, string> = {
    ['min-height']: isUsingOldPaddingStrategy ? '16px' : '40px',
  };
  const buttonStyles: Record<string, string> = {
    color: label.color.color1,
    background: getBackground(background.fill),
    ...makeFontStyles(font),
    ...makeFontStyleStyles(font?.style, '700'),
    ...makeLabelHorizontalAlignStyles(label?.align || 'center'),
    ['font-weight']: fontWeight,
  };
  if (iconPosition === 'right') {
    buttonStyles['flex-direction'] = 'row-reverse';
  }
  if (background.outline.selectorType !== 'none' && background.outlineWidth !== '0px') {
    wrapperStyles['border'] = `${background.outlineWidth} solid ${background.outline.color1}`;
  }
  if (background.radius !== '0px') {
    wrapperStyles['border-radius'] = background.radius;
  }

  return { buttonStyles, wrapperStyles };
}
